<template>
  <div>
    <button type="button" @click="$emit('clicked')" class="btn btn-outline-danger">
      <span v-if="!iconOnly">{{ $t(i18nMessage) }}</span>
      <span v-if="iconOnly" class="icon icon-loeschen" aria-hidden="true"></span>
      <span v-if="iconOnly" class="sr-only"> {{ $t(i18nMessage) }}</span>
    </button>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ButtonDelete',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.delete'
    },
    iconOnly: {
      type: Boolean,
      default: false
    }
  }
});
</script>
